import { defineStore } from 'pinia'

export default defineStore({
    id: 'offer',
    state: () => ({
        offer: {},
        studentOffer: {},
        currentSlideIndex: 0,
        updateOffer: false
    }),
    getters: {
        getAvailableOffer: (state) => state.offer,
        getStudentOffer: (state) => state.studentOffer,
        getCurrentSlideIndex: (state) => state.currentSlideIndex,
        getUpdateOffer: (state) => state.updateOffer,
        getIntroText: (state) => state?.studentOffer?.introText || '',
        getIntroTitle: (state) => state?.studentOffer?.introTitle || '',
        getIntroButtonText: (state) => state?.studentOffer?.introButtonText || ''
    },
    actions: {
        setOffer(offer) {
            if (offer.coupons) {
                offer.coupons.sort((a, b) => a.position - b.position)
            }
            this.offer = offer
        },
        setStudentOffer(offer) {
            if (offer.coupons) {
                offer.coupons.sort((a, b) => a.position - b.position)
            }
            this.studentOffer = offer
        },
        setCurrentSlideIndex(index) {
            this.currentSlideIndex = index
        },
        setUpdateOffer(value) {
            this.updateOffer = value
        }
    }
})
